@if (hasProductImage) {
  <img
    class="image"
    [src]="fullUrl"
    (error)="onFailToLoad($event)" />
}

@if (!hasProductImage) {
  <mat-icon
    class="missing">
    photo_camera
  </mat-icon>
}
